
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { motion } from 'framer-motion';
import { FaArrowRight, FaPlay } from 'react-icons/fa';
import './MiningTransport.css';

import heroBg from '../../Assets/Services/Minning/Background.png';
// Using placeholders
import introImage from '../../Assets/Services/Minning/Ship.png';
import whyChooseImage from '../../Assets/Services/Minning/Truck.png';

const MiningTransport = () => {

    // ScrollToTop component in App.js handles scrolling on route change

    const fadeInUp = {
        hidden: { opacity: 0, y: 50 },
        visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
    };

    return (
        <div className="mining-transport">

            {/* Hero Section */}
            <div className="mining-hero" style={{ backgroundImage: `url(${heroBg})` }}>
                <Container>
                    <motion.div
                        className="mining-hero-content"
                        initial={{ opacity: 0, x: -50 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.8 }}
                    >
                        <h1>Mining & Surface Transport</h1>
                        <p>Reliable bulk material and mining logistics solutions across industrial and extraction sites.</p>
                    </motion.div>
                </Container>
            </div>

            {/* Intro Section */}
            <section className="mining-intro">
                <Container>
                    <Row>
                        <Col md={12}>
                            <motion.div
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true }}
                                variants={fadeInUp}
                            >
                                <img src={introImage} alt="Mining Transport" className="img-fluid" />
                            </motion.div>
                        </Col>
                        <Col md={12} className="mt-4">
                            <motion.div
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true }}
                                variants={fadeInUp}
                            >
                                <h2>Specialized Transport for Mining & Bulk Materials</h2>
                                <p>
                                    Janta Roadways provides end-to-end mining and surface transport solutions tailored for coal, minerals, aggregates, and bulk
                                    industrial materials. Our fleet of heavy-duty tippers and dump trucks is engineered to operate in demanding terrain and high-
                                    load environments.
                                    <br />
                                    With decades of operational experience, we support mining companies, infrastructure projects, and industrial plants with
                                    dependable and timely material movement.
                                    <br />
                                    Our focus remains on safety, load integrity, and operational efficiency in every dispatch.
                                </p>
                            </motion.div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Why Choose Section */}
            <section className="mining-why-choose">
                <Container>
                    <Row className="align-items-center">
                        <Col md={6}>
                            <motion.div
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true }}
                                variants={fadeInUp}
                            >
                                <h2>Why Choose Our Mining Transport</h2>
                                <span className="subtitle">Built for tough terrain. Driven by operational discipline.</span>

                                <ul className="why-choose-list">
                                    <li><span className="icon"><FaArrowRight size={12} /></span> Heavy-duty tipper fleet</li>
                                    <li><span className="icon"><FaArrowRight size={12} /></span> High-volume bulk transport capability</li>
                                    <li><span className="icon"><FaArrowRight size={12} /></span> Experienced site-trained drivers</li>
                                    <li><span className="icon"><FaArrowRight size={12} /></span> CMVR-compliant and safety-first operations</li>
                                    <li><span className="icon"><FaArrowRight size={12} /></span> Preventive fleet maintenance program</li>
                                </ul>
                            </motion.div>
                        </Col>
                        <Col md={6}>
                            <motion.div
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true }}
                                variants={fadeInUp}
                            >
                                <img src={whyChooseImage} alt="Mining Operation" className="why-choose-image shadow-sm" />
                            </motion.div>
                        </Col>
                    </Row>
                </Container>
            </section>

            {/* Process Framework */}
            <section className="mining-process">
                <Container>
                    <Row className="align-items-center">
                        <Col md={7}>
                            <motion.div
                                className="video-placeholder shadow"
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true }}
                                variants={fadeInUp}
                            >
                                <div className="play-button">
                                    <FaPlay size={20} />
                                </div>
                            </motion.div>
                        </Col>
                        <Col md={5}>
                            <motion.div
                                className="process-content"
                                initial="hidden"
                                whileInView="visible"
                                viewport={{ once: true }}
                                variants={fadeInUp}
                            >
                                <h2>Our Mining Transport Process</h2>
                                <div className="process-steps">
                                    <div className="process-step">Requirement Analysis</div>
                                    <div className="process-step">Fleet Allocation</div>
                                    <div className="process-step">On-Site Coordination</div>
                                    <div className="process-step">Monitoring & Control</div>
                                    <div className="process-step">Safe Delivery & Reporting</div>
                                </div>
                            </motion.div>
                        </Col>
                    </Row>
                </Container>
            </section>
        </div>
    );
};

export default MiningTransport;
